import { isSet, isString } from '@/global/utils/utils'

const helperMixin = {
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },

  methods: {
    generateUuid () {
      return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
        (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
      )
    },

    /**
     * Resolve route parameter value.
     *
     * @param {string} paramName
     * @return {*|null}
     */
    resolveRouteParamValue (paramName) {
      if (!isSet(paramName) || !isString(paramName)) {
        return null
      }
      const paramValue = this.$route?.params?.[paramName]
      return paramValue ?? null
    }
  }
}

export default helperMixin
